export default "__VITE_ASSET__Bq0K1jgM__"